import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { MessageService } from '../../../@pages/components/message/message.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Page } from '../../../shared/models/page.model';
import { isArray } from 'util';
import { ErrorHandlingService } from '../../../shared/services/error-handling.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { Location } from '@angular/common';
import * as $ from 'jquery';
import { POSModel } from '../../../shared/models/pos.model';
import { POSService } from '../../../shared/services/pos.service';

@Component({
  selector: 'app-pos-detail',
  templateUrl: './pos-detail.component.html',
  styleUrls: ['./pos-detail.component.scss']
})
export class POSDetailComponent implements OnInit {

  @Input() external:boolean = false;
  @Output() saveEvent:EventEmitter<any> = new EventEmitter<any>();
  pos: POSModel;
  posForm: FormGroup;
  roles: any[];
  @ViewChild('mdSlideUp', { static: true }) mdSlideUp: ModalDirective;
  errors: String[] = [];
  ColumnMode = ColumnMode;
  constructor(
    private cdr: ChangeDetectorRef,
    private posService: POSService,
    private fb: FormBuilder,
    private router: Router,
    private snapshot: ActivatedRoute,
    private authService: AuthService,
    private messageService: MessageService,
    private errorHandler: ErrorHandlingService,
    private _location: Location
  ) { }

  ngOnInit() {
    let _this = this;
    this.createForm({});
    this.loadLocalities();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.messageService.remove();
      }
    });
    this.snapshot.paramMap.subscribe(res => {
      if (res['params']['id'] && !_this.external) {
        this.loadPOS(res['params']['id']);
      }
    })
  }

  menuItems: any[] = [
    { action: 'delete', message: 'Delete POS', class: '', icon: 'fal fa-trash', permissions: ['delete_pos'] }
  ];

  handleButtonPress(event) {
    switch (event) {
      case "delete":
        this.mdSlideUp.show();
        break;
      default:
        console.log(event);
        break;
    }
  }

  loadLocalities() {
    let _this = this;
    // this.localityService.getAll().subscribe(res => {
    //   _this.localities = res['data'];
    // },
    // err => {
    //   console.log(err);
    // })
  }

  @ViewChild('loadData', { static: true }) loadDataModal: ModalDirective;
  loadSavedData() {
    if (localStorage.getItem("pos-create")) {
      this.createForm(JSON.parse(localStorage.getItem("pos-create")));
      // if (this.posForm.get('phone').value) {
      //   this.posForm.get('phone').setValue(this.posForm.get('phone').value['nationalNumber'].replace(" ", ""));
      // }
    }
    this.posForm.markAllAsTouched();
    this.loadDataModal.hide();
  }

  deleteData() {
    localStorage.removeItem("pos-create");
    this.loadDataModal.hide();
  }

  sendBack() {
    this._location.back();
  }

  page: Page[] = [new Page(), new Page(), new Page()];
  currentPage: number[] = [1, 1, 1];
  searchParams = [{ per_page: 1000, page: this.currentPage[0] }, { per_page: 1000, page: this.currentPage[1] }, { per_page: 1000, page: this.currentPage[2] }];

  markTouched() {
    this.posForm.markAsTouched();
  }

  createForm(input?) {
    input = input || {};
    this.posForm = this.fb.group({
      title: [input.title, Validators.required],
      device: [input.device, Validators.required],
      transaction_ledger_detail:[input.transaction_ledger_detail, Validators.required]
    });
  }

  openFileUpload(ele) {
    $(ele).click();
  }

  hasPermission(permission) {
    return this.authService.hasPermission(permission);
  }

  uploadFile(fileInput) {
    console.log(fileInput);
    if (fileInput.target.files && fileInput.target.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e: any) {
        console.log(e.target.result);
        //$('#preview').attr('src', e.target.result);
      }
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  isTouched(controlName) {
    if (this.posForm.get(controlName).touched && this.posForm.get(controlName).invalid) {
      return true;
    }
    else {
      return false;
    }
  }

  loading = {
    isFirstLoad:false,
    isLoading:false
  };
  loadPOS(id) {
    let _this = this;
    if(!_this.loading.isFirstLoad){
      _this.loading.isFirstLoad = true;
      _this.loading.isLoading = true; 
    }
    this.posService.get(id).subscribe(res => {
      _this.pos = res['data'];
      _this.createForm(_this.pos);
      _this.loading.isLoading = false;
    },
    err => {
      _this.loading.isLoading = false;
      console.log(err);
    });
  }

  delete() {
    let _this = this;
    this.isLoading = true;
    this.posService.delete(this.pos.id).subscribe(res => {
      this.router.navigate(['/pos']);
      this.messageService.remove();
      this.messageService.success("pos Deleted.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
      _this.isLoading = false;
    },
      err => {
        this.messageService.remove();
        this.messageService.error(this.errorHandler.getErrors(err)[0], { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        console.log(err);
        _this.isLoading = false;
      });
  }

  showSlideUp() {
    this.mdSlideUp.show();
  }

  @Input() isLoading:boolean = false;
  save() {
    this.posForm.updateValueAndValidity();
    if (this.posForm.invalid) {
      this.posForm.markAllAsTouched();
      this.isLoading = false;
      return;
    }

    if(this.isLoading){
      return;
    }

    localStorage.removeItem("pos-create");
    let _this = this;

    _this.isLoading = true;

    let rawValue = this.posForm.getRawValue();
    this.posForm.markAsUntouched();
    this.posForm.updateValueAndValidity();
    
    if (this.pos) {
      this.posService.edit(this.pos.id, rawValue).subscribe(res => {
        this.messageService.remove();
        this.messageService.success("POS Updated.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        console.log(res['data']);
        _this.createForm(res['data']);
        console.log(_this.posForm);
        _this.isLoading = false;
      },
        err => {
          _this.errors = _this.errorHandler.getErrors(err);
          this.messageService.remove();
          this.messageService.error(_this.errorHandler.getErrors(err)[0], { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
          console.log(err);
          _this.isLoading = false;
        });
    }
    else {
      this.posService.create(rawValue).subscribe(res => {
        if(_this.external == true){
          _this.saveEvent.emit(res['data']);
        }
        else{
          this.router.navigate(['/pos/' + res['data']['id']]);
        }
        this.messageService.remove();
        this.messageService.success("POS Added.", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        _this.isLoading = false;
      },
        err => {
          _this.errors = _this.errorHandler.getErrors(err);
          console.log(err);
          _this.isLoading = false;
        });
    }
  }


}
